<template>
    <div class="wechat-kf-container">
      <!-- PC端：悬浮按钮 + 二维码弹窗 -->
      <div v-if="isPC" class="pc-kf-wrapper">
        <div
          class="kf-main-btn"
          @mouseenter="showQrcode = true"
          @mouseleave="handleMouseLeave"
          @click="toggleQrcode"
        >
        <!-- <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.5 11.5C8.5 12.3284 7.82843 13 7 13C6.17157 13 5.5 12.3284 5.5 11.5C5.5 10.6716 6.17157 10 7 10C7.82843 10 8.5 10.6716 8.5 11.5Z" fill="white"/>
  <path d="M16.5 11.5C16.5 12.3284 15.8284 13 15 13C14.1716 13 13.5 12.3284 13.5 11.5C13.5 10.6716 14.1716 10 15 10C15.8284 10 16.5 10.6716 16.5 11.5Z" fill="white"/>
  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="white"/>
</svg> -->
<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.5 11.5C8.5 12.3284 7.82843 13 7 13C6.17157 13 5.5 12.3284 5.5 11.5C5.5 10.6716 6.17157 10 7 10C7.82843 10 8.5 10.6716 8.5 11.5Z" fill="white"/>
  <path d="M16.5 11.5C16.5 12.3284 15.8284 13 15 13C14.1716 13 13.5 12.3284 13.5 11.5C13.5 10.6716 14.1716 10 15 10C15.8284 10 16.5 10.6716 16.5 11.5Z" fill="white"/>
  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="white"/>
</svg>
<!-- <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2C6.48 2 2 6.48 2 12C2 14.93 3.55 17.5 5.93 19.05L4.5 21.5C4.3 21.8 4.55 22.2 4.9 22.1L8.1 21.2C9.3 21.6 10.6 21.9 12 21.9C17.52 21.9 22 17.42 22 11.95C22 6.48 17.52 2 12 2Z" fill="white"/>
  <circle cx="8" cy="12" r="1.5" fill="white"/>
  <circle cx="12" cy="12" r="1.5" fill="white"/>
  <circle cx="16" cy="12" r="1.5" fill="white"/>
</svg> -->
          <!-- <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 13c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z"/>
          </svg> -->
        </div>
        <transition name="fade">
          <div v-if="showQrcode" class="kf-qrcode-panel" @mouseenter="clearTimer" @mouseleave="hideQrcodeDelayed">
            <div class="qrcode-title">微信扫码联系客服</div>
            <div ref="qrcodeContainer" class="qrcode-container"></div>
            <!-- <div class="qrcode-desc">微信识别二维码<br />即可开始对话</div> -->
            <div class="close-tip" @click="showQrcode = false">[ 关闭 ]</div>
          </div>
        </transition>
      </div>
  
      <!-- 移动端：悬浮球 + 直接跳转 -->
      <div v-else class="mobile-kf-wrapper">
        <div class="float-customer-service" @click="openMobileKF">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 13c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z"/>
          </svg>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // 动态引入二维码库（避免服务端渲染报错）
  let QRCode = null
  if (typeof window !== 'undefined') {
    QRCode = require('qrcodejs2')
  }
  
  export default {
    name: 'WechatCustomerService',
    props: {
      // 微信客服链接（必填）
      kfUrl: {
        type: String,
        required: true,
        default: ''
      },
      // 是否显示客服组件
      visible: {
        type: Boolean,
        default: true
      },
      // PC端按钮位置（右下角偏移量）
      pcOffsetRight: {
        type: String,
        default: '30px'
      },
      pcOffsetBottom: {
        type: String,
        default: '30px'
      }
    },
    data() {
      return {
        isPC: true, // 是否为PC端
        showQrcode: false, // PC端二维码弹窗显示
        hideTimer: null // 延迟关闭定时器
      }
    },
    watch: {
      // 监听客服链接变化，重新生成二维码
      kfUrl: {
        handler(newUrl) {
          if (newUrl && this.isPC && this.$refs.qrcodeContainer) {
            this.generateQRCode(newUrl)
          }
        },
        immediate: true
      },
      // 监听弹窗显示，每次打开时重新生成二维码（确保内容最新）
      showQrcode(val) {
        if (val && this.isPC && this.kfUrl) {
          this.$nextTick(() => {
            this.generateQRCode(this.kfUrl)
          })
        }
      }
    },
    mounted() {
      this.detectDevice()
      window.addEventListener('resize', this.detectDevice)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.detectDevice)
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
      }
    },
    methods: {
      /**
       * 检测设备类型（PC / 移动端）
       */
      detectDevice() {
        const userAgent = navigator.userAgent
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i
        this.isPC = !mobileRegex.test(userAgent)
      },
  
      /**
       * 生成二维码
       */
      generateQRCode(url) {
        if (!this.$refs.qrcodeContainer || !QRCode) return
        
        // 清空容器
        this.$refs.qrcodeContainer.innerHTML = ''
        
        try {
          // 生成新二维码
          new QRCode(this.$refs.qrcodeContainer, {
            text: url,
            width: 120,
            height: 120,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        } catch (error) {
          console.error('二维码生成失败:', error)
        }
      },
  
      /**
       * 移动端打开客服
       */
      openMobileKF() {
        if (!this.kfUrl) {
          console.warn('微信客服链接未配置')
          return
        }
        
        // 判断是否在微信内置浏览器内
        const isWechat = /MicroMessenger/i.test(navigator.userAgent)
        
        if (isWechat) {
          // 在微信内：直接跳转
          window.location.href = this.kfUrl
        } else {
          // 在外部浏览器：尝试跳转，并给出提示
          window.location.href = this.kfUrl
          // 延迟提示，避免快速跳转时弹窗
          setTimeout(() => {
            alert('正在跳转微信，如果未成功，请复制链接到微信打开')
          }, 500)
        }
      },
  
      /**
       * PC端：鼠标离开按钮时延迟关闭二维码
       */
      handleMouseLeave() {
        this.hideTimer = setTimeout(() => {
          this.showQrcode = false
        }, 200)
      },
  
      /**
       * PC端：清除延迟关闭定时器
       */
      clearTimer() {
        if (this.hideTimer) {
          clearTimeout(this.hideTimer)
          this.hideTimer = null
        }
      },
  
      /**
       * PC端：延迟关闭二维码
       */
      hideQrcodeDelayed() {
        this.hideTimer = setTimeout(() => {
          this.showQrcode = false
        }, 200)
      },
  
      /**
       * PC端：点击按钮切换二维码显示
       */
      toggleQrcode() {
        this.clearTimer()
        this.showQrcode =  true
      }
    }
  }
  </script>
  
  <style scoped>
  /* ========== 通用样式 ========== */
  .wechat-kf-container {
    position: fixed;
    z-index: 9999;
    top: 50%;
    right: 2px;
    transform: translateY(-50%);
  }
  
  /* ========== PC端样式 ========== */
  .pc-kf-wrapper {
    position: fixed;
    right: v-bind(pcOffsetRight);
    bottom: v-bind(pcOffsetBottom);
  }
  
  .kf-main-btn {
    width: 65px;
    height: 65px;
    background: #07c160;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
  }
  
  .kf-main-btn:hover {
    transform: scale(1.05);
    background: #06ad56;
  }
  
  .kf-main-btn svg {
    width: 40px;
    height: 40px;
    fill: white;
  }
  
  /* 二维码弹窗 */
  .kf-qrcode-panel {
    position: absolute;
    bottom: 90px;
    right: 0;
    background: white;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    padding: 20px 20px 16px 20px;
    text-align: center;
  }
  
  .qrcode-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 12px;
    font-weight: bold;
  }
  
  .qrcode-container {
    display: flex;
    justify-content: center;
  }
  
  .qrcode-desc {
    font-size: 12px;
    color: #999;
    margin-top: 12px;
  }
  
  .close-tip {
    font-size: 11px;
    color: #ccc;
    margin-top: 8px;
    cursor: pointer;
  }
  
  .close-tip:hover {
    color: #999;
  }
  
  /* 过渡动画 */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  /* ========== 移动端样式 ========== */
  .mobile-kf-wrapper {
    position: fixed;
    right: 16px;
    bottom: 80px;
  }
  
  .float-customer-service {
    width: 56px;
    height: 56px;
    background-color: #07c160;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .float-customer-service:active {
    transform: scale(0.95);
  }
  
  .float-customer-service svg {
    width: 28px;
    height: 28px;
    fill: white;
  }
  </style>